/**
* This file is DEPRECATED.
*
* It supports a few older dialogs (med samples, doc med, imaging orders, etc.)
* via two jQuery methods: el8_simpleInputDialog and el8_inputDialog.
*
* The current equivalent is FormDialog
*/

goog.provide('el8.uiwidget.Dialog');

goog.require('el8.util.consts');

(function($) {

    /**
    * Base Dialog
    * @params {Object} spec Specification for Dialog...
    *   container: div container for the Dialog
    *   buttons: buttons to be displayed in Dialog
    *   savedOffsets:
    *   closeElt:
    *   heightBuffer, widthBuffer
    *   preferredWidth, preferredHeight
    *   minHeight, minWidth
    *   maxHeight, maxWidth
    *   position:
    *   rememberPosition:
    *   minimizeFn:
    *   title:
    *   dialogClass:
    *   dialogTitlebarClass:
    *   closeFn:
    *   closeOnEscape:
    *   disableTitlebarClose:
    *   disableTitlebarMinimize:
    *   disableTitlebarExpand:
    *   isDraggable:
    *   isResizeable:
    *   resizeFn:
    *   isModal:
    *   overlay:
    *   zIndex:
    *   containerId:
    *   leftMargin, rightMargin, topMargin, bottomMargin
    *   leftOffset:
    * @returns {Object} Returns the created jQuery Dialog
    * @note Function is not available outside this namespace
    */
    function baseDialog( spec ) {

        var that = {};
        var container = spec.container;

        var savedOffsets = spec.savedOffsets || null; // [ left, top ]

        // Specified buffer is 2x desired buffer on each side
        var heightBuffer = ( spec.heightBuffer !== undefined ) ? spec.heightBuffer : 50;
        var widthBuffer = ( spec.widthBuffer !== undefined ) ? spec.widthBuffer : 50;

        var preferredWidth = spec.preferredWidth || 600;
        var preferredHeight = spec.preferredHeight || $(window).height() - heightBuffer;

        var maxHeight = (spec.isResizable === true) ? ( spec.maxHeight || null ) : null;
        var minHeight = (spec.isResizable === true) ? ( spec.minHeight || null ) : null;
        var maxWidth = (spec.isResizable === true) ?
            ( (spec.resizeHeightOnly === true) ? preferredWidth : ( spec.maxWidth || null ) ) : null;
        var minWidth = (spec.isResizable === true) ?
            ( (spec.resizeHeightOnly === true) ? maxWidth : ( spec.minWidth || null ) ) : null;

        var position = spec.position || 'center';

        var rememberPosition = ( spec.rememberPosition !== false ); // defaults to true

        var focus = spec.focus || null;
        var blur = spec.blur || null;

        var minimizeFn;
        if( rememberPosition ) {
            minimizeFn = function() {
                if( that.isVisible() ) {
                    var borderSize = el8.util.consts.DIALOG_BORDER; // TODO: HACK
                    savedOffsets = [ that.getDialog().offset().left - borderSize,
                        that.getDialog().offset().top - borderSize ];
                    if( spec.minimizeFn ) {
                        spec.minimizeFn( savedOffsets );
                    }
                }
            };
        } else if( spec.minimizeFn ) {
            minimizeFn = spec.minimizeFn;
        }
        that.minimize = minimizeFn || function() {};

        container.dialog({
            autoOpen: false,
            stack: true,

            buttons: spec.buttons || {},
            title: spec.title || 'NONE',
            dialogClass: spec.dialogClass || '',
            dialogTitlebarClass: spec.dialogTitlebarClass || '',

            closeFn: spec.closeFn || null,
            closeOnEscape: (spec.closeOnEscape === true), // defaults to false
            disableTitlebarClose: ( spec.disableTitlebarClose === true ), // defaults to false

            disableTitlebarMinimize: ( spec.disableTitlebarMinimize !== false ), // defaults to true
            minimizeFn: minimizeFn || null,

            disableTitlebarExpand: ( spec.disableTitlebarExpand !== false ), // defaults to true

            draggable: (spec.isDraggable !== false), // defaults to true
            resizable: (spec.isResizable === true), // defaults to false
            resizeFn: spec.resizeFn || null,

            modal: (spec.isModal === true), // defaults to false
            overlay: spec.overlay || {},

            height: preferredHeight,
            width: preferredWidth,
            maxHeight: maxHeight,
            maxWidth: maxWidth,
            minHeight: minHeight,
            minWidth: minWidth,

            zIndex: spec.zIndex || 1000,

            focus: focus,
            blur: blur
        });

        that.getDialog = function() {
            return $(container.parent());
        };

        // Set containerId if specified
        if( spec.containerId ) {
            that.getDialog().attr('id', spec.containerId);
        }
        that.getDialog().addClass('el8Dialog');

        that.adjustSize = function() {
            container.dialog('adjustSize');
        };

        that.getDialogHeight = function() {
            var result = that.getDialog();
            return result.height();
        };

        that.getDialogWidth = function() {
            var result = that.getDialog();
            return result.width();
        };

        that.getExpandTrigger = function() {
            if( spec.disableTitlebarExpand === false ) {
                var result = that.getDialog();
                return result.find('.ui-dialog-titlebar-expand');
            }
            return null;
        };

        that.setTitle = function(title) {
            that.getDialog().find('div.ui-dialog-titlebar > span.ui-dialog-title').text(title);
        };

        that.setStackable = function(isStackable) {
            container.dialog("option", "stack", (isStackable!==false));
        };
        that.setDraggable = function(isDraggable) {
            container.dialog("setDraggable", (isDraggable!==false));
        };
        that.setModal = function(isModal) {
            container.dialog("option", "modal", (isModal!==false));
        };
        that.setTitle = function(title) {
            container.dialog("option", "title", title);
        };

        function setSize() {

            var windowHeight = $(window).height();
            var windowWidth = $(window).width();

            // Set size
            if( preferredHeight ) {
                // only set height explicitly if requested or required due to screen size
                that.setHeight( Math.min( preferredHeight, windowHeight - heightBuffer ) );
            } else {
                var height = that.getHeight();
                if( height > windowHeight - heightBuffer ) {
                    that.setHeight( windowHeight - heightBuffer );
                }
            }

            if( preferredWidth > windowWidth - widthBuffer ) {
                that.setWidth( windowWidth - widthBuffer );
            } else {
                var width = that.getWidth();
                if( width > windowWidth - widthBuffer ) {
                    that.setWidth( windowWidth - widthBuffer );
                }
            }
        }

        function setPosition() {

            var windowHeight = $(window).height();
            var windowWidth = $(window).width();

            var width = that.getWidth();
            var height = that.getHeight();

            var leftOffset = spec.leftOffset || 0;
            var topMargin = spec.topMargin || 0;

            if( position === 'center' || position === 'trueCenter' ) {

                var left;

                if( position === 'center' ) {
                    // Container will be centered over screen minus REF_PANEL_WIDTH
                    // with specified offsets
                    // Make sure there is at least 15px margin on RHS after centering
                    if( windowWidth - el8.util.consts.REF_PANEL_WIDTH - leftOffset - width < 30 ) {
                        left = windowWidth - width - 15;
                    } else {
                        left = leftOffset + el8.util.consts.REF_PANEL_WIDTH +
                            ( windowWidth - el8.util.consts.REF_PANEL_WIDTH - width ) / 2;
                    }

                } else if( position === 'trueCenter' ) {
                    // Same as "center" except doesn't include reference panel offset
                    // Make sure there is at least 15px margin on RHS
                    if( windowWidth - leftOffset - width < 30 ) {
                        left = windowWidth - width - 15;
                    } else {
                        left = leftOffset + ( windowWidth - width ) / 2;
                    }
                }

                // Set top margin
                var top = topMargin + ( ( windowHeight - topMargin ) / 2 ) - ( height / 2 );

                that.setPosition( [ left, top ] );

            } else if( position === 'bottomRight' ) {

                // Leave 10 pixels for scrollbar
                var rightMargin = ( spec.rightMargin !== undefined ) ? spec.rightMargin : 10;

                // Leave 12 pixels for bottom menubar
                var bottomMargin = ( spec.bottomMargin !== undefined ) ? spec.bottomMargin : 12;

                // Set a minimum on LHS to not cover reference panel
                var minLeftMargin = 280;
                // But don't push form off page
                var left = Math.min(Math.max(windowWidth - width - rightMargin, minLeftMargin), windowWidth-width-10);

                var top = Math.max( windowHeight - height - bottomMargin, 0 );

                that.setPosition( [ left, top ] );

            } else if( position === 'left' ) {
                var left = el8.util.consts.REF_PANEL_WIDTH + (spec.leftOffset || 0);
                // Set top margin
                var top = topMargin + ( ( windowHeight - topMargin ) / 2 ) - ( height / 2 );
                that.setPosition( [ left, top ] );
            }

        }

        that.setHeight = function( height, setOverflow ) {
            container.dialog('option', 'height', height);
        };
        that.getHeight = function() { return container.dialog('option', 'height'); };
        that.setWidth = function( width ) { container.dialog('option', 'width', width); };
        that.getWidth = function() { return container.dialog('option', 'width'); };
        that.setTopMargin = function( margin ) {
            var currLeftMargin = container.offset().left - el8.util.consts.DIALOG_BORDER;

            container.dialog('option', 'position', $.ui.dialog.getPositionObject([ currLeftMargin, margin ]));
        };
        that.setLeftMargin = function( margin, topOffset ) {
            var currTopMargin = container.offset().top;
            if (topOffset) { currTopMargin -= topOffset; }
            container.dialog('option', 'position', $.ui.dialog.getPositionObject([ margin, currTopMargin ]));
        };
        that.setRightMargin = function( margin ) {
            var currTopMargin = container.offset().top; //TODO need to subtract pixels for header
            var leftMargin = $(window).width() - that.getWidth() - margin;
            container.dialog('option', 'position', $.ui.dialog.getPositionObject([ leftMargin, currTopMargin ]));
        };
        that.setPosition = function( arr ) { container.dialog('option', 'position', $.ui.dialog.getPositionObject(arr)); };

        that.show = function( setLastPosition, formSavedOffsets, noPosition ) {
            savedOffsets = savedOffsets || formSavedOffsets || null;
            container.removeClass('hidden');
            if( that.isVisible() ) {
                container.dialog('moveToTop');
            } else {
                container.dialog('open');
                if( (setLastPosition === true) && (savedOffsets !== null) ) {
                    that.setPosition( savedOffsets );
                    savedOffsets = null;
                } else {
                    if( !setLastPosition ) {
                        setSize();
                    }
                    // Only if noPosition is not explicitly at true...
                    if(noPosition !== true) {
                        setPosition();
                    }
                }
            }
        };

        that.isVisible = function() { return container.dialog('isOpen'); };

        // If dialog is going to be init again later,
        // then needs to be destroyed
        that.hideResetAndDestroy = function() {
            that.hide();
            that.resetForms();
            container.dialog('destroy');
        };

        that.destroy = function() {
            container.dialog('destroy');
        };

        that.hide = function() {
            if( rememberPosition ) {
                var borderSize = el8.util.consts.DIALOG_BORDER; // TODO: HACK
                savedOffsets = [ that.getDialog().offset().left - borderSize,
                    that.getDialog().offset().top - borderSize ];
            }
            container.addClass('hidden');
            container.dialog('close');
        };

        that.resetForms = function() {
            container.is("form") ? container.resetForm() : container.find('form')[0].reset();
        };

        that.disableForms = function() {
            container.find('input').prop('disabled', true);
            container.find('textarea').prop('disabled', true);
            container.find('select').prop('disabled', true);
            container.find('button').prop('disabled', true);
        };

        that.enableForms = function() {
            container.find('input').prop('disabled', false);
            container.find('textarea').prop('disabled', false);
            container.find('select').prop('disabled', false);
            container.find('button').prop('disabled', false);
        };

        return that;
    }

    /**
    * Simple draggable Input Dialog
    * @params {Object} spec Specifications identical to the baseDialog
    * @previously_named el8.ui.simpleInputDialog
    */
    $.fn.el8_simpleInputDialog = function(spec) {
        spec = spec || {};
        spec.container = this;
        spec.isModal = (spec.isModal === true); // defaults to false
        spec.isDraggable = true;
        spec.isResizable = false;
        spec.position = 'center';
        spec.closeOnEscape = false;
        var that = baseDialog(spec);

        that.bindTabListeners = function(firstFieldSelector) {
            bindTabListeners(that.getDialog(), firstFieldSelector);
        };
        that.unbindTabListeners = function() {
            unbindTabListeners(that.getDialog());
        };

        return that;
    };

    /**
    * Form based dialog, positioned bottomRight
    * @params {Object} spec Specifications identical to the baseDialog
    * @returns {Object} Returns generated jQuery Dialog (Object)
    * @previously_named el8.ui.inputDialog
    */
    $.fn.el8_inputDialog = function(spec) {
        spec = spec || {};
        spec.container = this;
        spec.isModal = spec.isModal ? spec.isModal : false;
        spec.isDraggable = spec.isDraggable ? spec.isDraggable : true;
        spec.isResizable = spec.isResizable ? spec.isResizable : false;
        spec.position = spec.position ? spec.position : 'bottomRight';
        spec.closeOnEscape = spec.closeOnEscape ? spec.closeOnEscape : false;

        var that = baseDialog( spec );

        var expanded = false;  // describes the current desired state
        that.isExpanded = function() { return expanded; };
        that.setExpanded = function( val ) { expanded = val; };
        that.resetExpanded = function() { expanded = false; };

        var super_show = that.show;
        that.show = function( setLastPosition, savedOffsets ) {
            if( !that.isVisible() ) {
                if( expanded && that.expandHeight ) {
                    that.expandHeight();
                }
                // If !expanded, defaults to opening in "restored" state
            }
            super_show( setLastPosition, savedOffsets );
        };

        that.makeExpandable = function( newSpec ) {

            if( newSpec.initTriggerText ) {
                that.getExpandTrigger().text( newSpec.initTriggerText );
            }

            // Make expandable / restorable
            var expandFn = newSpec.expandFn;
            var restoreFn = newSpec.restoreFn;

            that.expandHeight = function() {
                var windowHeight = $(window).height();
                var height = windowHeight - 40 - 40; // 40 is for the bottom toolbar
                that.setHeight( height );
                that.setTopMargin((windowHeight/2) - (height/2) - 10);
                that.adjustSize();
                if( expandFn ) { expandFn(); }
                expanded = true;
            };

            that.restoreHeight = function() {
                var windowHeight = $(window).height();
                var height = spec.preferredHeight || 600;
                that.setHeight( height );
                // Put at bottom of window
                that.setTopMargin( windowHeight - height - (spec.bottomMargin || 0 ) );
                that.adjustSize();
                if( restoreFn ) { restoreFn(); }
                expanded = false;
            };
        };

        that.bindTabListeners = function(firstFieldSelector) {
            bindTabListeners(that.getDialog(), firstFieldSelector);
        };
        that.unbindTabListeners = function() {
            unbindTabListeners(that.getDialog());
        };

        return that;
    };

    /**
     * Attach these as that.bindTabListeners and that.unbindTabListeners to
     * any dialog which needs circular tabbing and highlighting of radios/checkboxes.
     * Call bindTabListeners on show() and unbindTabListeners on hide().
     *
     * firstFieldSelector is a JQuery selector for the first input to highlight
     */
     function bindTabListeners(dialogContainer, firstFieldSelector) {
        // Bind tabcatcher so that users can tab around the dialog in a loop
        var $firstField;
        if (firstFieldSelector) {
            $firstField = $(firstFieldSelector, dialogContainer);
        } else {
            $firstField = $('input', dialogContainer).first();
        }
        dialogContainer.on('focus', '.tabcatcher',  function() {
            $firstField.scrollintoview().focusSelect();
        });
        $firstField.focusSelect();

        dialogContainer.on('focus', 'input:checkbox',  addLabelFocus)
            .on('blur', 'input:checkbox',  removeLabelFocus)
            .on('focus', 'input:radio',  addLabelFocus)
            .on('blur', 'input:radio',  removeLabelFocus);
    }

    function unbindTabListeners(dialogContainer) {
        dialogContainer.off('focus', '.tabcatcher')
            .off('focus', 'input:checkbox', addLabelFocus)
            .off('blur', 'input:checkbox', removeLabelFocus)
            .off('focus', 'input:radio', addLabelFocus)
            .off('blur', 'input:radio', removeLabelFocus);
    }

    /**
     * Listeners for radios/checkboxes which highlight the input's
     * associated label when the input receives focus
     */
    function addLabelFocus(e) {
        $(e.target).parent('label').addClass('focus');
    }
    function removeLabelFocus(e) {
        $(e.target).parent('label').removeClass('focus');
    }

})(jQuery);
